import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthImage from '../images/auth/codeframe.png';
import Logo from '../images/auth/logo (2).png';
import { IoIosChatboxes } from "react-icons/io";
import { IoMdCheckmark } from "react-icons/io";
import { IoMailOutline } from "react-icons/io5";

const VerifySignupChannel = () => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleOptionSelect = (option) => {
        setSelectedOption(option);
    };

    const handleProceed = async () => {
        if (!selectedOption) return;
        
        setIsLoading(true);
        
        try {
            // Get verification_id from local storage
            const verificationId = localStorage.getItem('quickcare-verification-id');
            if (!verificationId) {
                console.error('Verification ID not found');
                return;
            }

            // Determine channel based on selected option
            const channel = selectedOption === 'sms' ? 'phone_number' : 'email';
            
            // Make API call
            const myHeaders = new Headers();
            myHeaders.append("Accept", "application/json");

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow"
            };

            const response = await fetch(
                `https://devapi.quickcare.ng/api/v1/user/signup/resend?verification_id=${verificationId}&channel=${channel}`,
                requestOptions
            );

            const result = await response.json();
            console.log(result);

            if (result.success) {
                // If successful, navigate to OTP page
                navigate('/signup/otp');
            } else {
                console.error('Failed to send verification code');
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex flex-col md:flex-row bg-white instrument-sans-normal">
            {/* Left side - Form */}
            <div className="w-full md:w-1/2 flex items-center justify-center p-4 md:p-8 lg:p-12">
                <div className="w-full max-w-md space-y-8">
                    <div className="">
                        <img src={Logo} alt="Company Logo" className='w-[196px] h-[49px]'/>
                        <h2 className="mt-6 text-2xl instrument-sans-semibold text-gray-700">
                            Verification Type
                        </h2>
                    </div>
                    
                    <div className='w-full flex flex-col space-y-4'>
                        <button 
                            className={`w-full flex items-center justify-between py-6 px-4 border rounded-lg transition-all duration-200 ${
                                selectedOption === 'sms' 
                                    ? 'border-[#069125]' 
                                    : 'border-[#E9EBE9] hover:border-[#069125]'
                            }`}
                            onMouseEnter={() => handleOptionSelect('sms')}
                            onClick={() => handleOptionSelect('sms')}
                        >
                            <p className='flex items-center gap-2'>
                                <IoIosChatboxes className={`text-xl ${
                                    selectedOption === 'sms' ? 'text-[#069125]' : 'text-[#8B8D8C]'
                                }`}/>
                                <span className='text-[#8B8D8C]'>
                                    Via SMS
                                </span>
                            </p>

                            {selectedOption === 'sms' && <IoMdCheckmark className='text-xl text-[#069125]'/>}
                        </button>

                        <button 
                            className={`w-full flex items-center justify-between py-6 px-4 border rounded-lg transition-all duration-200 ${
                                selectedOption === 'email' 
                                    ? 'border-[#069125]' 
                                    : 'border-[#E9EBE9] hover:border-[#069125]'
                            }`}
                            onMouseEnter={() => handleOptionSelect('email')}
                            onClick={() => handleOptionSelect('email')}
                        >
                            <p className='flex items-center gap-2'>
                                <IoMailOutline className={`text-xl ${
                                    selectedOption === 'email' ? 'text-[#069125]' : 'text-[#8B8D8C]'
                                }`}/>
                                <span className='text-[#8B8D8C]'>
                                    Via email
                                </span>
                            </p>

                            {selectedOption === 'email' && <IoMdCheckmark className='text-xl text-[#069125]'/>}
                        </button>
                    </div>

                    <div className='pt-4'>
                        <button
                            onClick={handleProceed}
                            disabled={!selectedOption || isLoading}
                            className={`w-full py-3 px-4 rounded-lg text-white ${
                                selectedOption && !isLoading
                                    ? 'bg-[#069125] hover:bg-[#057a20] cursor-pointer' 
                                    : 'bg-gray-300 cursor-not-allowed'
                            } transition-colors duration-200`}
                        >
                            {isLoading ? 'Processing...' : 'Proceed'}
                        </button>
                    </div>
                </div>
            </div>

            {/* Right side - Background Image (hidden on mobile) */}
            <div 
                className="hidden md:block md:w-1/2 bg-indigo-50 bg-cover bg-center bg-no-repeat"
                style={{ backgroundImage: `url(${AuthImage})` }}
            >
                {/* Optional: You can add content over the background image here if needed */}
            </div> 
        </div>
    );
};

export default VerifySignupChannel;